import { render, staticRenderFns } from "./Evidencia.vue?vue&type=template&id=50424b2a"
import script from "./Evidencia.vue?vue&type=script&lang=js"
export * from "./Evidencia.vue?vue&type=script&lang=js"
import style0 from "./Evidencia.vue?vue&type=style&index=0&id=50424b2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports